import { useState } from 'react';

interface FaqItem {
  q: string;
  a: string;
}

const faqData: FaqItem[] = [
  {
    q: '51吃瓜黑料是什么平台？',
    a: '51吃瓜黑料是一个专注于娱乐八卦与热点事件爆料的聚合平台，汇集全网最新吃瓜爆料、黑料曝光及网曝门事件内幕，每日实时更新独家猛料，是吃瓜爱好者的必访阵地。',
  },
  {
    q: '平台上的爆料内容可信吗？',
    a: '我们平台的内容来源多渠道交叉验证，包含一手信源投稿与公开信息整理。每条爆料均标注信息来源与可信度评级，建议读者理性看待，独立判断。我们始终坚持客观呈现、不造谣不传谣的原则。',
  },
  {
    q: '如何第一时间获取最新爆料？',
    a: '将51吃瓜黑料加入浏览器收藏夹即可随时访问。首页"实时快讯"模块按时间倒序展示最新内容，"热度榜单"帮你快速定位当日最受关注的爆料，确保你不会错过任何重要吃瓜动态。',
  },
  {
    q: '我可以投稿爆料吗？',
    a: '当然可以！我们欢迎广大吃瓜群众贡献一手线索。请通过页面底部"联系我们"区域的投稿入口提交你的爆料内容。所有投稿均会严格保密投稿人信息，经核实后将署名发布。',
  },
  {
    q: '51吃瓜黑料是否收费？',
    a: '完全免费！51吃瓜黑料对所有用户永久免费开放，无需注册即可浏览全部内容。我们的初心就是打造一个开放、透明的吃瓜社区，让每个人都能够自由获取和分享信息。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问答
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于51吃瓜黑料，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl border border-background-200 overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left bg-background-50 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <h3 className="font-semibold text-foreground-900 text-sm md:text-base pr-4">
                  {item.q}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === idx ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-500 text-lg"></i>
                </div>
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-5 pt-1">
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    {item.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}